// extracted by mini-css-extract-plugin
export default {"inputResponse":"intervention-detail-table_inputResponse__hVI5H","block":"intervention-detail-table_block__aRouv","information":"intervention-detail-table_information__xncmy"};